/** @format */

import React from 'react';
import SuperAgent from 'superagent';
import ModalPortal, {
    ModalHeader,
    ModalFooter,
    ModalSubtitle,
    ModalBody
} from 'frontier-admin/modal/container_portal';
import {Icon, Input, Button} from '@sttark/design-system';

// styles
import './container.sass';
import {ConditionalButton} from 'frontier-utilities';
import {PasswordValidator} from 'frontier/utilities/password_validator';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false,
            email: '', // The email to look for
            emailAccepted: false, // Did we find a valid email address
            resetPasswordCode: '', // The reset code to look for
            codeVerified: false, // Did the user supply the correct code
            newPassword: '', // The new password
            newPasswordMatch: '', // The password confirmation
            passwordReset: false, // Did the password update successfully,
            isValidPassword: false // password must meet requirements
        };
    }

    handleChange = (field, value) => {
        let state = {};
        state[field] = value;
        this.setState(state);
    };

    handleGetCode = () => {
        this.setState({
            loading: true,
            emailAccepted: false,
            error: false
        });

        SuperAgent.post('/legacy/users/forgot-password')
            .set('Accept', 'application/json')
            .send({email: this.state.email})
            .end((err, response) => {
                if (err) {
                    this.setState({
                        error: response.body,
                        emailAccepted: false,
                        loading: false
                    });
                } else {
                    this.setState({
                        emailAccepted: true,
                        loading: false,
                        error: false
                    });
                }
            });
    };

    handleVerifyCode = () => {
        this.setState({
            loading: true,
            codeVerified: false,
            error: false
        });

        SuperAgent.post('/legacy/users/verify-password-code')
            .set('Accept', 'application/json')
            .send({email: this.state.email, resetPasswordCode: this.state.resetPasswordCode})
            .end((err, response) => {
                if (err) {
                    this.setState({
                        error: response.body,
                        codeVerified: false,
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: false,
                        codeVerified: true
                    });
                }
            });
    };

    handleResetPassword = () => {
        if (this.state.newPassword !== this.state.newPasswordMatch) {
            this.setState({
                error: {message: 'Oh my! Your passwords do not match.'}
            });
        } else {
            this.setState({
                loading: true,
                passwordReset: false,
                error: false
            });

            SuperAgent.post('/legacy/users/reset-password')
                .set('Accept', 'application/json')
                .send({
                    email: this.state.email,
                    resetPasswordCode: this.state.resetPasswordCode,
                    newPassword: this.state.newPassword,
                    newPasswordMatch: this.state.newPasswordMatch
                })
                .end((err, response) => {
                    if (err) {
                        this.setState({
                            error: response.body,
                            passwordReset: false,
                            loading: false
                        });
                    } else {
                        this.setState({
                            passwordReset: true,
                            loading: false,
                            error: false
                        });
                    }
                });
        }
    };

    render() {
        return (
            <ModalPortal noCard maxWidth="600px">
                <div className="login-modal-card bg-structure-white">
                    <ModalHeader newestds onClose={this.props.onClose}>
                        Login Help
                    </ModalHeader>

                    <ModalBody newestds={true}>
                        {(this.state.emailAccepted && !this.state.codeVerified) ||
                        (this.state.emailAccepted &&
                            this.state.codeVerified &&
                            this.state.passwordReset) ? (
                            <ModalSubtitle>
                                <span className="color-alert-positive">Success!</span>
                            </ModalSubtitle>
                        ) : (
                            <ModalSubtitle>Reset Password</ModalSubtitle>
                        )}
                        {this._getEmail()}
                        {this._getCodeInput()}
                        {this._getNewPasswordInput()}
                        <div className="additional-desc">
                            <p className="font-body-bold-md additional-desc_title">
                                Get Additional Help
                            </p>
                            <p className="font-body-md additional-desc_desc">
                                If you are unable to resolve your login issues, reach out to our
                                Customer Care team.
                            </p>
                            <div className="d-flex align-items-start justify-content-start additional-desc_icons">
                                <div className="d-flex align-items-center justify-content-center">
                                    <Icon name="phone" color="#000000" />
                                    <p>(877) 277-4682</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Icon name="chat" color="#000000" />
                                    <p>Chat Now</p>
                                </div>
                            </div>
                        </div>
                    </ModalBody>

                    <div className="modal-footer card_footer d-flex align-items-center justify-content-end border-top border-darker">
                        {this._getDoneButton()}
                        {this._getResetPasswordButton()}
                        {this._getVerifyButton()}
                        {this._getInitialButton()}
                    </div>
                </div>
            </ModalPortal>
        );
    }

    _getEmail = () => {
        if (!this.state.emailAccepted) {
            return (
                <div>
                    <p className="font-body-sm description">
                        Enter your email address. We will send an email containing a link to reset
                        your password.
                    </p>
                    <div className="forgot-password-input form-group border-bottom border-darker">
                        <Input
                            label="*Email"
                            type="Enter your email"
                            error={this._getError()}
                            value={this.state.email}
                            onChange={this.handleChange.bind(this, 'email')}
                            className="form-control"
                        />
                    </div>
                </div>
            );
        }

        return;
    };

    _getError = () => {
        const errorIsInvalidCode =
            this.state.error &&
            this.state.error?.message.includes('Your link is invalid or has expired');
        const errorIsInvalidEmail =
            this.state.error &&
            this.state.error?.message.includes('The email provided does not match');

        return errorIsInvalidEmail
            ? 'The email provided does not match an account on file. Please check your entry and try again or create an account'
            : errorIsInvalidCode
            ? 'The code you entered is invalid or has expired. Please try again or request a new one.'
            : this.state.error?.message;

        return;
    };

    _getCodeInput = () => {
        if (this.state.emailAccepted && !this.state.codeVerified) {
            return (
                <div>
                    <div className="">
                        <p className="font-body-sm description">
                            We have sent a code to <strong>{this.state.email}</strong>. Please copy
                            and paste that code below
                        </p>
                    </div>
                    <div className="form-group">
                        <Input
                            type="text"
                            label="verification Code"
                            error={this._getError()}
                            placeholder="Enter Verification Code"
                            value={this.state.resetPasswordCode}
                            onChange={this.handleChange.bind(this, 'resetPasswordCode')}
                            newestds
                        />
                    </div>
                </div>
            );
        }
        return;
    };

    _getNewPasswordInput = () => {
        if (this.state.emailAccepted && this.state.codeVerified && this.state.passwordReset) {
            return (
                <p className="font-body-sm description mb-6">
                    Your password has been reset. Close this window and login with your new
                    password! Oh, and have a great day!
                </p>
            );
        } else if (
            this.state.emailAccepted &&
            this.state.codeVerified &&
            !this.state.passwordReset
        ) {
            return (
                <div>
                    <p className="font-body-sm description">Please reset your password below</p>
                    <div className="form-group">
                        <Input
                            type="password"
                            label="New Password"
                            placeholder="Enter New Password"
                            value={this.state.newPassword}
                            onChange={this.handleChange.bind(this, 'newPassword')}
                        />
                        {this.state.newPassword && (
                            <PasswordValidator
                                input={this.state.newPassword}
                                handleIsValidPassword={val => this.setState({isValidPassword: val})}
                            />
                        )}
                    </div>
                    <div className="form-group">
                        <Input
                            label="Confirm Password"
                            placeholder="Please Confirm Your Password"
                            type="password"
                            value={this.state.newPasswordMatch}
                            onChange={this.handleChange.bind(this, 'newPasswordMatch')}
                        />
                    </div>
                    {this._getError()}
                </div>
            );
        }

        return;
    };

    // buttons
    _getVerifyButton = () => {
        if (this.state.emailAccepted && !this.state.codeVerified)
            return (
                <Button
                    disabled={this.state.loading}
                    className="mb-3"
                    primary
                    large
                    onClick={this.handleVerifyCode}
                    label={this.state.loading ? 'verifying' : 'Verify Code'}
                />
            );

        return;
    };

    _getResetPasswordButton = () => {
        if (this.state.emailAccepted && this.state.codeVerified && !this.state.passwordReset)
            return (
                <Button
                    disabled={this.state.loading || !this.state.isValidPassword}
                    onClick={this.handleResetPassword}
                    large
                    primary
                    label={this.state.loading ? 'saving' : 'Reset Password'}
                />
            );
        return;
    };

    _getDoneButton = () => {
        if (this.state.emailAccepted && this.state.codeVerified && this.state.passwordReset)
            return <Button primary large onClick={this.props.onClose} label="Done" />;
        return;
    };

    _getInitialButton = () => {
        if (!this.state.emailAccepted && !this.state.codeVerified && !this.state.passwordReset)
            return (
                <Button
                    primary
                    large
                    onClick={this.state.loading ? () => {} : this.handleGetCode}
                    label={
                        this.state.loading
                            ? 'Sending Code'
                            : this.state.error
                            ? 'Try Again'
                            : 'Send Reset Link'
                    }
                />
            );
        return;
    };
}

export default ForgotPassword;
